// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-update[data-v-3310692a]{position:fixed;height:200px;width:300px;background:#264678;z-index:10001;right:20px;top:20px;box-shadow:0 3px 6px rgba(0,0,0,0.16),0 3px 6px rgba(0,0,0,0.23);padding:40px}p[data-v-3310692a]{text-align:center;color:#fff;font-size:18px}.controls[data-v-3310692a]{margin-top:20px;text-align:center}\n", ""]);
// Exports
module.exports = exports;
